module.exports = __webpack_public_path__ + "img/parkpay.c80fc22c.png";